import { render, staticRenderFns } from "./DocumentosPreaspirante.vue?vue&type=template&id=5da864ef&scoped=true"
import script from "./DocumentosPreaspirante.vue?vue&type=script&lang=js"
export * from "./DocumentosPreaspirante.vue?vue&type=script&lang=js"
import style0 from "./DocumentosPreaspirante.vue?vue&type=style&index=0&id=5da864ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da864ef",
  null
  
)

export default component.exports